// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getStorage } from "firebase/storage";

// Your Firebase configuration object
const firebaseConfig = {
    apiKey: "AIzaSyAtzCV9Vf_mvw-U86qi4KTUNRS4UA1K1L8",
    authDomain: "power-edge.firebaseapp.com",
    projectId: "power-edge",
    storageBucket: "power-edge.firebasestorage.app",
    messagingSenderId: "586772017627",
    appId: "1:586772017627:web:a6b8fe02aa4129b1bb37fe",
    measurementId: "G-F7MKVFNN7W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only if running in a browser)
let analytics;
if (typeof window !== "undefined") {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}

export const storage = getStorage(app);

export { app, analytics };